(function() { module.exports = window["Next"]["Checkbox"]; }());